  function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    // this.header = this.header || document.getElementById('shopify-section-header');
    // this.header = this.header || document.getElementById('shopify-section-pub-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
   
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
    
      var elem = document.querySelector('body');
      if (elem.classList.contains('product')) {
        this.updatePricePerItem();
        this.updatePriceToSpend();
      }
     
      
      this.updateMedia();
      if(!elem.classList.contains('template-collection')) {
       this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      if (elem.classList.contains('template-collection')) {
        this.updateCollectionPrice();
      }

      this.updateProductButtonPrice();
      setTimeout(() => this.updateProductButtonPrice(), 300);
      setTimeout(() => this.updateProductButtonPrice(), 800);
      
    }
  }
  updateCollectionPrice() {

     
     if(this.closest('product-form') != null) {
       const quickAddForm = this.closest('product-form');
       const sellingPlanInput = quickAddForm.querySelector('input[name="selling_plan"]');
       const selectedSellingPlanId = sellingPlanInput && !sellingPlanInput.disabled ? sellingPlanInput.value : '';
       const selectedSellingPlanAllocation = selectedSellingPlanId && this.currentVariant && this.currentVariant.selling_plan_allocations
         ? this.currentVariant.selling_plan_allocations.find((allocation) => String(allocation.selling_plan_id) === String(selectedSellingPlanId)) || this.currentVariant.selling_plan_allocations[0]
         : null;

       if(this.closest('product-form').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse(this.closest('product-form').querySelector('[data-product-json]').textContent);
        // console.log('productJson', productJson);

           if(productJson.options.length > 0) {
             let packSizeIndex = -1;
             productJson.options.forEach((option, index) => {
                let optionName = option.toLowerCase();
                if(optionName.includes("pack size")) {
                    packSizeIndex = index;
                }
             });
             let productTags = productJson.tags.toString().toLowerCase();
              if(productTags.includes("type_") && packSizeIndex >= 0) {
                let packNumber = Number(this.currentVariant.options[packSizeIndex].toLowerCase().replace('pack', ''));
                let unitPrice = this.currentVariant.price/packNumber;
              
                  if(this.closest('product-form').querySelector('.rc_widget__option__input:checked') != null) {
                    let optionValue = this.closest('product-form').querySelector('.rc_widget__option__input:checked').value; 
                     //console.log('optionValue', optionValue);
                    if(optionValue == 'onetime') {
                      unitPrice = this.currentVariant.price/packNumber;
                    }
                    else if(optionValue == 'subsave') {
                        unitPrice = (selectedSellingPlanAllocation ? selectedSellingPlanAllocation.price : this.currentVariant.selling_plan_allocations[0].price)/packNumber;
                    }
                  }
                  if(this.closest('product-form').querySelector('[data-breakdown-price]') != null) {
                    this.closest('product-form').querySelector('[data-breakdown-price]').innerText = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(unitPrice / 100));
                    this.closest('product-form').querySelector('[data-breakdown-price]').setAttribute('data-pack-number', packNumber);
                  }
                  if(this.closest('product-form').querySelector('.breakdown') != null) {
                    this.closest('product-form').querySelector('.breakdown').classList.remove('hidden');
                  }
                
              }
           }

         
           //   productJson.variants.forEach((variant, index) => { 
           //      productJson.options.forEach((option, index) => { 
               
           //      });
           //  });
           // }
            
              // const fieldsets = Array.from(this.querySelectorAll('fieldset'));
              // this.options = fieldsets.map((fieldset) => {
              //  console.log('fieldset', fieldset);
              //   let optionName = '';
              //   let optionIndex = 0;
              //   let selectedValues = '';
              //   productJson.variants.forEach((variant, index) => { 
              //      if(variant.options[optionIndex] == selectedValues) {
                      
              //      }
              //   });
              // });
       }

       if(this.closest('product-form').querySelector('[data-price-subsave]') != null) {
          const subsavePrice = selectedSellingPlanAllocation ? selectedSellingPlanAllocation.price : this.currentVariant.selling_plan_allocations[0].price;
          this.closest('product-form').querySelector('[data-price-subsave]').innerHTML = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(subsavePrice/ 100));
       }
        if(this.closest('product-form').querySelector('[data-price-onetime]') != null) {
         this.closest('product-form').querySelector('[data-price-onetime]').innerHTML = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(this.currentVariant.price/ 100));
       }
     }
    
   }
  formatThemeMoney(price) {
    return (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(price / 100));
  }

  getVariantPackCount(variant) {
    if (!variant) return 0;

    const valuesToCheck = [];
    if (variant.options && variant.options.length) {
      valuesToCheck.push(...variant.options);
    }
    if (variant.title) {
      valuesToCheck.push(variant.title);
    }

    for (const value of valuesToCheck) {
      if (!value) continue;

      const packMatch = String(value).match(/(\d+)\s*pack/i);
      if (packMatch) {
        return Number(packMatch[1]);
      }

      const plainNumberMatch = String(value).match(/^(\d+)$/);
      if (plainNumberMatch) {
        return Number(plainNumberMatch[1]);
      }
    }

    return 0;
  }

  getSelectedSellingPlanAllocation(variant) {
    if (!variant || !variant.selling_plan_allocations || variant.selling_plan_allocations.length === 0) {
      return null;
    }

    const productTemplate = this.closest('[data-product-template]');
    if (!productTemplate) {
      return variant.selling_plan_allocations[0];
    }

    const rechargeWidget = productTemplate.querySelector('recharge-subscription-widget');
    const rechargeWidgetRoot = rechargeWidget && rechargeWidget.shadowRoot ? rechargeWidget.shadowRoot : null;
    if (rechargeWidgetRoot) {
      const selectedPurchaseOption = rechargeWidgetRoot.querySelector('input[name="purchaseOption"]:checked');
      if (selectedPurchaseOption && selectedPurchaseOption.value === 'onetime') {
        return null;
      }

      const widgetPlanId = rechargeWidgetRoot.querySelector('select[name="rc_plan"]')?.value;
      if (widgetPlanId) {
        return variant.selling_plan_allocations.find((allocation) => String(allocation.selling_plan_id) === String(widgetPlanId)) || variant.selling_plan_allocations[0];
      }

      if (selectedPurchaseOption && selectedPurchaseOption.value === 'subscription') {
        return variant.selling_plan_allocations[0];
      }
    }

    const productForm = productTemplate.querySelector('form[action*="/cart/add"]');
    const sellingPlanInput = productForm ? productForm.querySelector('input[name="selling_plan"]') : null;
    const selectedPlanIdFromForm = sellingPlanInput ? sellingPlanInput.value : '';
    if (selectedPlanIdFromForm) {
      return variant.selling_plan_allocations.find((allocation) => String(allocation.selling_plan_id) === String(selectedPlanIdFromForm)) || variant.selling_plan_allocations[0];
    }

    const purchaseOption = productTemplate.querySelector('.product__info-wrapper .rc_widget__option__input:checked');
    if (!purchaseOption || purchaseOption.value === 'onetime') {
      return null;
    }

    const selectedPlanId = productTemplate.querySelector('.rc-selling-plans-dropdown__select')?.value;
    if (!selectedPlanId) {
      return variant.selling_plan_allocations[0];
    }

    return variant.selling_plan_allocations.find((allocation) => String(allocation.selling_plan_id) === String(selectedPlanId)) || variant.selling_plan_allocations[0];
  }

  getActiveVariantPrice(variant) {
    const activeAllocation = this.getSelectedSellingPlanAllocation(variant);

    return {
      activeAllocation,
      activePrice: activeAllocation ? activeAllocation.price : variant.price,
      activeComparePrice: activeAllocation ? activeAllocation.compare_at_price : variant.compare_at_price
    };
  }

  updateProductVariantOptionPrices() {
    const productTemplate = this.closest('[data-product-template]');
    if (!productTemplate) return;

    const perCanTargets = productTemplate.querySelectorAll('[data-variant-option-per-can]');
    if (!perCanTargets.length) return;

    const productData = this.getVariantData();
    const variantMap = new Map(productData.map((variant) => [String(variant.id), variant]));

    perCanTargets.forEach((target) => {
      const variant = variantMap.get(String(target.dataset.variantId));
      if (!variant) return;

      const { activePrice } = this.getActiveVariantPrice(variant);
      const packCount = this.getVariantPackCount(variant);
      target.textContent = packCount > 0 ? `${this.formatThemeMoney(activePrice / packCount)}/can` : '';
    });
  }

  updateProductButtonPrice() {
    if (!this.currentVariant) return;

    const productTemplate = this.closest('[data-product-template]');
    if (!productTemplate) return;

    const priceTarget = productTemplate.querySelector('[data-product-button-price]');
    const compareTarget = productTemplate.querySelector('[data-product-button-compare-price]');
    const perCanTarget = productTemplate.querySelector('[data-product-per-can]');
    if (!priceTarget) return;

    const { activePrice, activeComparePrice } = this.getActiveVariantPrice(this.currentVariant);

    priceTarget.textContent = this.formatThemeMoney(activePrice);

    if (compareTarget) {
      if (activeComparePrice && activeComparePrice !== activePrice) {
        compareTarget.textContent = this.formatThemeMoney(activeComparePrice);
        compareTarget.classList.remove('hidden');
      } else {
        compareTarget.textContent = '';
        compareTarget.classList.add('hidden');
      }
    }

    if (perCanTarget) {
      const packCount = this.getVariantPackCount(this.currentVariant);
      if (packCount > 0) {
        perCanTarget.textContent = `${this.formatThemeMoney(activePrice / packCount)}/can`;
      } else {
        perCanTarget.textContent = '';
      }
    }

    this.updateProductVariantOptionPrices();
  }
  updateOptions() {
    
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

    console.log('this.options 1: ', this.options)
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    console.log('this.currentVariant ', this.currentVariant)
    console.log('this.options 2: ', this.options)

    if(document.querySelector('.style--pack-size-wrapper')){
      if(this.options[0] === 'Cans'){
        
        document.querySelector(`.bottles-pack-size`).style.opacity = 0;
        document.querySelector(`.bottles-pack-size`).style.pointerEvents = 'none';

        document.querySelector(`.cans-pack-size`).style.opacity = 1;
        document.querySelector(`.cans-pack-size`).style.pointerEvents = 'auto';


        if( document.querySelector(`.cans-pack-size input:checked`) == null) {
          if(document.querySelectorAll(`.cans-pack-size input[type="radio"]`)[0] != undefined) {
            document.querySelectorAll(`.cans-pack-size input[type="radio"]`)[0].click();
          }
        }
        

        // const selected_value = document.getElementById('slider_cans').value;

        // if(!this.currentVariant){
        //   if(typeof cansPackSizeRangeSlide === 'function') {
        //       cansPackSizeRangeSlide.setValues(parseInt(selected_value));
        //   }
        // } else {
        //   if(this.options[1] !== selected_value){
        //     if(typeof cansPackSizeRangeSlide === 'function') {
        //       cansPackSizeRangeSlide.setValues(parseInt(selected_value));
        //     }
        //   }
        // }
        
      }

      if(this.options[0] === 'Bottles'){
        document.querySelector(`.cans-pack-size`).style.opacity = 0;
        document.querySelector(`.cans-pack-size`).style.pointerEvents = 'none';

        document.querySelector(`.bottles-pack-size`).style.opacity = 1;
        document.querySelector(`.bottles-pack-size`).style.pointerEvents = 'auto';


         if( document.querySelector(`.bottles-pack-size input:checked`) == null) {
          if(document.querySelectorAll(`.bottles-pack-size input[type="radio"]`)[0] != undefined) {
            document.querySelectorAll(`.bottles-pack-size input[type="radio"]`)[0].click();
          }
        }
        
        const selected_value = document.getElementById('slider_bottles').value;
        if(!this.currentVariant){
          if (typeof bottlesPackSizeRangeSlide === 'function') {
            bottlesPackSizeRangeSlide.setValues(parseInt(selected_value));
          }
        } else {
          if(this.options[1] !== selected_value){
             if (typeof bottlesPackSizeRangeSlide === 'function') {
                bottlesPackSizeRangeSlide.setValues(parseInt(selected_value));
             }
          }
        }
      }
    }

  }

  updatePriceToSpend() {
    
    var breakdown = document.querySelector('.breakdown');
    breakdown.classList.remove('hidden');

    var priceSub = document.querySelector('.sub-price');
    var priceNormal = document.querySelector('.normal-price');
    
    if(priceNormal.querySelector('.price-item.price-item--regular')){
      priceNormal.querySelector('.price-item.price-item--regular').textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(this.currentVariant.price / 100))
  
      console.log('this.currentVariant.price: ', this.currentVariant.price)
    }

    const { activeAllocation, activePrice } = this.getActiveVariantPrice(this.currentVariant);

    if (activeAllocation) {
      priceSub.classList.remove('hidden');
    } else {
      priceNormal.classList.remove('hidden');
    }

    var currentVariantHTML = document.querySelector('.current-variant');

    currentVariantHTML.textContent = (this.currentVariant.title);

    var cartTotal = document.querySelector('.cart-message');
    var cartTotal = cartTotal.getAttribute('data-total');
    var cartTotal = (cartTotal / 100);

    var spendThreshold = document.querySelector('.spend-promo');
    var spendThreshold = spendThreshold.getAttribute('data-price');
    var spendThreshold = (spendThreshold / 100);

    
    
    var currentPrice = this.currentVariant.price;
    var latestPrice = (activePrice || currentPrice) / 100;
    currentPrice = (currentPrice / 100);
    
    var newSpend = (spendThreshold - cartTotal - latestPrice);

    var spendToDisplay = (cartTotal + latestPrice);
    
    var spendWrapper = document.querySelector('.product__info-wrapper .spending-wrapper');
    var toReach = document.querySelector('.product__info-wrapper .to-reach');
    var toSpend = document.querySelector('.product__info-wrapper .to-spend');
    var reached = document.querySelector('.product__info-wrapper .reached');

    toSpend.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(newSpend));

    var priceSubInsert = document.querySelector('.sub-price-insert');
    if (priceSubInsert) {
      priceSubInsert.textContent = this.formatThemeMoney(activeAllocation ? activePrice : this.currentVariant.price);
    }
    

    if(spendThreshold > spendToDisplay) {
      // console.log('spendThreshold more');
      toReach.classList.remove('hidden');
      reached.classList.add('hidden');
    } else {
      // console.log('spendThreshold less');
      toReach.classList.add('hidden');
      reached.classList.remove('hidden');
    }
  }

  updatePricePerItem() {

    var str = this.currentVariant.title;
    let $this = this;
    setTimeout(function () {



      


      const { activePrice } = $this.getActiveVariantPrice($this.currentVariant);
      let newPrice = activePrice || $this.currentVariant.price;

      var priceOfItem = '';
      if(str.split("/")[1] != undefined) {
        priceOfItem = Number(str.split("/")[1].toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
               
      var nameOfItem = str.split("/")[0];

      var nameOfItem = nameOfItem.slice(0, -2); 

      if($this.currentVariant.options.length == 1 ) {
         priceOfItem = Number(str.toLowerCase().replace('pack', '').replace(/\s+/g,''));
      }
      
   // console.log('NEW', newPrice, priceOfItem);
     // var priceOfItem = (num / priceOfItem);
     var priceOfItem = (newPrice / Number(priceOfItem));
     
  
      var priceText = document.querySelector('.breakdown-price');
      var itemText = document.querySelector('.breakdown-item');
  
      priceText.textContent = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(priceOfItem/100));

      if($this.currentVariant.options.length >= 2) {
          itemText.textContent = (nameOfItem);
      }
      
   


    //================For Subs options price
      
     if($this.closest('[data-product-template]') != null) {
       if($this.closest('[data-product-template]').querySelector('[data-product-json]') != null) {
          let productJson =  JSON.parse($this.closest('[data-product-template]').querySelector('[data-product-json]').textContent);
         // console.log('productJson - pro', productJson);

           if(productJson.options.length > 0) {
             let packSizeIndex = -1;
             productJson.options.forEach((option, index) => {
                let optionName = option.toLowerCase();
                if(optionName.includes("pack size")) {
                    packSizeIndex = index;
                }
             });
              let productTags = productJson.tags.toString().toLowerCase();
              if(productTags.includes("type_") && packSizeIndex >= 0) {

                let tagName = '';
                productJson.tags.forEach((tag) => {
                   let temp = tag.toLowerCase();
                    if(temp.includes('type_')) {
                       tagName = temp.replace('type_', '');
                    }
                });
             
                let packNumber = Number($this.currentVariant.options[packSizeIndex].toLowerCase().replace('pack', ''));
                let unitPrice = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format($this.currentVariant.price/packNumber / 100));
                let priceHTML = `<span>${unitPrice} per ${tagName}</span> ${(new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format($this.currentVariant.price/100))}`;
                if($this.closest('[data-product-template]').querySelector('.subscription-radio') != null) {
                    const selectedAllocation = $this.getSelectedSellingPlanAllocation($this.currentVariant) || $this.currentVariant.selling_plan_allocations[0];
                    let unitPriceSubs = (new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(selectedAllocation.price/packNumber / 100));
                    let priceSubsHTML = `<span>${unitPriceSubs} per ${tagName}</span> ${(new Intl.NumberFormat('en-UK', { style: 'currency', currency: 'GBP' }).format(selectedAllocation.price/100))}`;
                    if($this.closest('[data-product-template]').querySelector('.subscription-radio .price-label') != null) {
                      $this.closest('[data-product-template]').querySelector('.subscription-radio .price-label').innerHTML = priceSubsHTML;
                    }
                     if($this.closest('[data-product-template]').querySelector('.onetime-radio .price-label') != null) {
                      $this.closest('[data-product-template]').querySelector('.onetime-radio .price-label').innerHTML = priceHTML;
                    }
                }
              }
           }
       }
     }
      
     }, 500);
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if(mediaGallery != null) {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] span.add-text');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] span.add-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    var priceSub = document.querySelector('.sub-price');
    var breakdown = document.querySelector('.breakdown');
    priceSub.classList.add('hidden');
    breakdown.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    // this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }
}

customElements.define('variant-radios', VariantRadios);

function reveal() {
  var reveals = document.querySelectorAll(".reveal");

  for (var i = 0; i < reveals.length; i++) {
    var windowHeight = window.innerHeight;
    var elementTop = reveals[i].getBoundingClientRect().top;
    var elementVisible = 150;

    
  // console.log(elementTop);
  //   console.log(windowHeight - elementVisible);

    if (elementTop - 200 < windowHeight) {
      reveals[i].classList.add("active");
    } else {
      reveals[i].classList.remove("active");
    }
  }
}

window.addEventListener("scroll", reveal);

var isInViewport = function(elem) {
  var distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

var findMe = document.querySelectorAll('.animation-wrapper');

window.addEventListener('load', function(event) {
findMe.forEach(element => {
    if (isInViewport(element)) {
      // console.log('In the load viewport! :)');
      element.classList.add("animate");    
    } else {
      // console.log('Not in the load viewport! :)');
    }
});
}, false);

window.addEventListener('scroll', function(event) {
findMe.forEach(element => {
    if (isInViewport(element)) {
      // console.log('In the scroll viewport! :)');
      element.classList.add("animate");    
    } else {
      // console.log('Not in the scroll viewport! :)');
    }
});
}, false);


const details = document.querySelectorAll(".accordion");

// Add the onclick listeners.
details.forEach((targetDetail) => {
  targetDetail.addEventListener("click", () => {
    const isClickInside = targetDetail.contains(event.target)

    var child = targetDetail.querySelector('.animate-fade');

    void child.offsetWidth; 

    child.classList.toggle('active');
    
    // Close all the details that are not targetDetail.
    details.forEach((detail) => {
      var child = detail.querySelector('.animate-fade');
      
      if (detail !== targetDetail) {
        void child.offsetWidth; 
        detail.removeAttribute("open");
        child.classList.remove('active');
      }
    });
  });
});
